import { handleActions } from 'redux-actions';

import { types } from '../constants';
import { injuryConstants } from '../constants';

const INITIAL_STATE = {
  accidentsByBranch: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  },
  accidentsByCompany: {
    items: [],
    isLoading: false,
    errorMessage: ''
  }
};

const startFetchAllAccidentsForBranch = (state) => {
  return {
    ...state,
    accidentsByBranch: {
      ...state.accidentsByBranch,
      isLoading: true
    }
  };
};

const fetchAllAccidentsForBranchSuccess = (state, { accidents }) => {
  return {
    ...state,
    accidentsByBranch: {
      ...state.accidentsByBranch,
      items: accidents,
      itemsCopy: accidents
    }
  };
};

const fetchAllAccidentsForBranchFailure = (state, { errorMessage }) => {
  return {
    ...state,
    accidentsByBranch: {
      ...state.accidentsByBranch,
      errorMessage
    }
  };
};

const fetchAllAccidentsForBranchFinished = (state) => {
  return {
    ...state,
    accidentsByBranch: {
      ...state.accidentsByBranch,
      isLoading: false
    }
  };
};

const startFetchAllAccidentsForCompany = (state) => {
  return {
    ...state,
    accidentsByCompany: {
      ...state.accidentsByCompany,
      isLoading: true
    }
  };
};

const fetchAllAccidentsForCompanySuccess = (state, { accidents }) => {
  return {
    ...state,
    accidentsByCompany: {
      ...state.accidentsByCompany,
      items: accidents
    }
  };
};

const fetchAllAccidentsForCompanyFailure = (state, { errorMessage }) => {
  return {
    ...state,
    accidentsByCompany: {
      ...state.accidentsByCompany,
      errorMessage
    }
  };
};

const fetchAllAccidentsForCompanyFinished = (state) => {
  return {
    ...state,
    accidentsByCompany: {
      ...state.accidentsByCompany,
      isLoading: false
    }
  };
};

const changeSearchTermAllAccidents = (state, { searchTerm }) => {
  let accidents = [...state.accidentsByBranch.itemsCopy];
  let list = injuryConstants.injuryTypes;

  //Getting injuryTypes that have searchTerm in them.
  let filteredList = list.filter(
    (a) => a.value && a.value.toLowerCase().includes(searchTerm)
  );

  //Getting accidents whose injuryTypeId exists in above calculated filteredList.
  let filteredAccidents = accidents.filter((a) =>
    filteredList.some((l) => l.id === a.injuryTypeId)
  );

  if (searchTerm === '') {
    filteredAccidents = state.accidentsByBranch.itemsCopy;
  }

  return {
    ...state,
    accidentsByBranch: {
      ...state.accidentsByBranch,
      searchTerm,
      items: filteredAccidents
    }
  };
};

const submitAccidentSuccess = (state, { submittedAccident }) => {
  let accidents = [...state.accidentsByBranch.items];
  let updatedAccidentIndex = accidents.findIndex(
    (a) => a.id === submittedAccident.id
  );

  //Means updated
  if (updatedAccidentIndex !== -1) {
    accidents[updatedAccidentIndex] = submittedAccident;
  } else {
    accidents = [...accidents, submittedAccident];
  }

  return {
    ...state,
    accidentsByBranch: {
      ...state.accidentsByBranch,
      items: accidents,
      itemsCopy: accidents
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.START_FETCH_ALL_ACCIDENTS_FOR_BRANCH]: startFetchAllAccidentsForBranch,
    [types.FETCH_ALL_ACCIDENTS_FOR_BRANCH_SUCCESS]: fetchAllAccidentsForBranchSuccess,
    [types.FETCH_ALL_ACCIDENTS_FOR_BRANCH_FAILURE]: fetchAllAccidentsForBranchFailure,
    [types.FETCH_ALL_ACCIDENTS_FOR_BRANCH_FINISHED]: fetchAllAccidentsForBranchFinished,

    [types.START_FETCH_ALL_ACCIDENTS_FOR_COMPANY]: startFetchAllAccidentsForCompany,
    [types.FETCH_ALL_ACCIDENTS_FOR_COMPANY_SUCCESS]: fetchAllAccidentsForCompanySuccess,
    [types.FETCH_ALL_ACCIDENTS_FOR_COMPANY_FAILURE]: fetchAllAccidentsForCompanyFailure,
    [types.FETCH_ALL_ACCIDENTS_FOR_COMPANY_FINISHED]: fetchAllAccidentsForCompanyFinished,

    [types.CHANGE_SEARCH_TERM_ALL_ACCIDENTS]: changeSearchTermAllAccidents,

    [types.SUBMIT_ACCIDENT_SUCCESS]: submitAccidentSuccess
  },
  INITIAL_STATE
);
